<template>
  <div>
    <b-row class="mb-2">
      <b-col sm="12">
        <b-button variant="danger" @click="$router.go(-1)">Atrás</b-button>
      </b-col>
    </b-row>

    <b-row v-if="loan">
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información del Préstamo</h4>
          </b-card-header>
          <b-card-body class="mt-2">
            <b-row>
              <b-col sm="6" lg="2">
                <strong>Establecimiento Origen:</strong>
                <p>{{ loan.establishmentOrigin.name }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Cliente:</strong>
                <p>{{ loan.client.document }} - {{ loan.client.fullname }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Nro de Orden:</strong>
                <p>{{ loan.documentCode }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Nro de documento:</strong>
                <p>{{ loan.billNumber ? loan.billNumber : 'No tiene' }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Fecha Límite:</strong>
                <p>{{ formatDate(loan.limitDate) }}</p>
              </b-col>
              <b-col sm="6" lg="2">
                <strong>Venta realizada por:</strong>
                <p>{{ loan.registerBy ? loan.registerBy.fullname : 'No se ha realizado la venta' }}</p>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="bg-secondary border-b-2">
            <h4 class="text-white">Detalles del Préstamo</h4>
          </b-card-header>
          <b-card-text>
            <b-table
              :items="loanDetails"
              :fields="fields"
              responsive
              hover
              show-empty
              empty-text="No existen detalles"
            >
            <template #cell(state)="data">
              <span :class="getStateClass(data.item.state)">
                {{ data.item.state }}
              </span>
            </template>

            </b-table>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import LoanService from "@/services/LoanService";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      loan: null, 
      loanDetails: [], 
      fields: [
        { key: "autopart.uniqueCode", label: "Código Único", sortable: true },
        { key: "autopart.AutopartBrand.name", label: "Marca", sortable: false },
        { key: "autopart.originalCode", label: "Código Original", sortable: true },
        { key: "autopart.alterCode", label: "Código Alterno", sortable: true },
        { key: "autopart.description", label: "Descripción", sortable: false },
        { key: "qty", label: "Cantidad", sortable: true },
        { key: "unitPrice", label: "Precio Unitario", sortable: true },
        { key: "state", label: "Estado", sortable: true },
        { key: "observation", label: "Observación", sortable: false },
      ],
    };
  },
  mounted() {
    this.getLoanDetails();
  },
  methods: {
    getStateClass(state) {
      switch (state) {
        case 'Pendiente':
          return 'badge badge-warning';
        case 'Facturado':
          return 'badge badge-success';
        case 'Devuelto':
          return 'badge badge-danger';
        default:
          return 'badge badge-secondary';
      }
    },
    formatDate(date) {
      if (!date) return "Sin fecha";
    return date.split("T")[0];
    },
    
    async getLoanDetails() {
      try {
        const response = await LoanService.getLoanById(this.$route.params.id, this.$store);
        if (response && response.data) {
          this.loan = response.data.loan;
          this.loanDetails = response.data.loanDetails;
        } else {
          this.$swal("Error", "No se encontraron detalles del préstamo.", "error");
        }
      } catch (error) {
        console.error("Error al obtener el préstamo:", error);
        this.$swal("Error", "Ocurrió un problema al cargar los detalles del préstamo.", "error");
      }
    },
  },
};
</script>
